<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<div class="panel-wrapper" [ngClass]="{ 'panel-wrapper--loading': loading }">
  <app-buttons
    (save)="submit(true)"
    (close)="destroy(true)"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="form-container" [formGroup]="form">
    <mat-card>
      <mat-card-title>{{ label("DatosGenerales", "Datos Generales") }}</mat-card-title>
      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{ label("Nombre") }}</mat-label>
          <input matInput formControlName="Nombre" />
          <mat-error *ngIf="f['Nombre'].hasError('required')">
            {{ label("CampoRequerido", "Campo requerido") }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("Clave") }}</mat-label>
          <input
            matInput
            formControlName="Clave"
            maxlength="20"
            [readonly]="mode === 'U'"
          />
          <mat-error *ngIf="f['Clave'].hasError('required')">
            {{ label("CampoRequerido", "Campo requerido") }}
          </mat-error>
          <mat-error
            *ngIf="
              f['Clave'].hasError('pattern') && !f['Clave'].hasError('required')
            "
          >
            {{ label("FormatoInvalido", "Formato inválido") }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("Lugar") }}</mat-label>
          <mat-select formControlName="LugarId">
            <mat-option *ngFor="let lugar of lugares" [value]="lugar.pkId">
              {{ lugar.Nombre }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="descripcion-field">
          <mat-label>{{ label("Descripcion", "Descripción") }}</mat-label>
          <textarea matInput formControlName="Descripcion" rows="3"></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("Clase") }}</mat-label>
          <mat-select formControlName="Clase">
            <mat-option value="KUROI">{{ label("Kuroi", "Kuroi") }}</mat-option>
            <mat-option value="TORNO">{{ label("Torno", "Torno") }}</mat-option>
            <mat-option value="ESCANER">{{ label("Escaner", "Escáner") }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("TipoEntradaSalida", "Tipo Entrada/Salida") }}</mat-label>
          <mat-select formControlName="TipoEntSal">
            <mat-option value="E">Entrada</mat-option>
            <mat-option value="S">Salida</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("TipoAcceso", "Tipo Acceso") }}</mat-label>
          <mat-select formControlName="TipoAcceso">
            <mat-option value="NORMAL">{{ label("Normal", "Normal") }}</mat-option>
            <mat-option value="LOCAL">{{ label("Local", "Local") }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("TipoConexion", "Tipo Conexión") }}</mat-label>
          <mat-select formControlName="TipoConexion">
            <mat-option value="REMOTO">{{ label("Remoto", "Remoto") }}</mat-option>
            <mat-option value="LOCAL">{{ label("Local", "Local") }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="readonly-field">
          <span class="readonly-field__label">
            {{ label("BBDDCentralizada", "BBDD Centralizada") }}
          </span>
          <span class="readonly-field__value">
            {{ getCentralizadaLabel() }}
          </span>
        </div>
      </div>

      <mat-checkbox formControlName="DeBaja">
        {{ label("DeBaja", "De baja") }}
      </mat-checkbox>
    </mat-card>

    <mat-card [formGroup]="validationForm" *ngIf="mostrarValidaciones">
      <mat-card-title>{{ label("Validaciones", "Validaciones") }}</mat-card-title>
      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{ label("MargenInferior", "Margen inferior") }}</mat-label>
          <input matInput type="number" min="0" formControlName="CHMargenInferior" />
          <button mat-icon-button matSuffix matTooltip="{{ label('TiempoEnSegundos', 'Tiempo en segundos') }}">
            <mat-icon>info</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("MargenSuperior", "Margen superior") }}</mat-label>
          <input matInput type="number" min="0" formControlName="CHMargenSuperior" />
          <button mat-icon-button matSuffix matTooltip="{{ label('TiempoEnSegundos', 'Tiempo en segundos') }}">
            <mat-icon>info</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <div class="toggle-grid">
        <mat-slide-toggle formControlName="ValidacionEstandar">
          {{ label("ValidacionEstandar", "Validación estándar") }}
        </mat-slide-toggle>
        <mat-slide-toggle formControlName="ValidacionInternet">
          {{ label("ValidacionInternet", "Validación Internet") }}
        </mat-slide-toggle>
        <mat-slide-toggle formControlName="GuardarFichajesIncorrectos">
          {{ label("GuardarFichajesIncorrectos", "Guardar fichajes incorrectos") }}
        </mat-slide-toggle>
        <mat-slide-toggle formControlName="PermitirLocInexistentes">
          {{ label("PermitirLocalizadoresInexistentes", "Permitir localizadores inexistentes") }}
        </mat-slide-toggle>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{ label("NumeroPasosPrevios", "Número de pasos previos") }}</mat-label>
        <input matInput type="number" min="0" formControlName="NumPasosPrevios" />
      </mat-form-field>
    </mat-card>

    <mat-card [formGroup]="databaseForm">
      <mat-card-title>{{ label("BaseDatos", "Base de datos") }}</mat-card-title>
      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>{{ label("Proyecto", "Proyecto") }}</mat-label>
          <input matInput formControlName="NombreProyecto" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("Servidor", "Servidor") }}</mat-label>
          <input matInput formControlName="SQLServer" />
          <mat-error *ngIf="df['SQLServer'].hasError('pattern')">
            {{ label("FormatoInvalido", "Formato inválido") }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("BaseDatos", "Base de datos") }}</mat-label>
          <input matInput formControlName="SQLDataBase" />
          <mat-error *ngIf="df['SQLDataBase'].hasError('pattern')">
            {{ label("FormatoInvalido", "Formato inválido") }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("UsuarioSQL", "Usuario SQL") }}</mat-label>
          <input matInput formControlName="SQLUser" />
          <mat-error *ngIf="df['SQLUser'].hasError('pattern')">
            {{ label("FormatoInvalido", "Formato inválido") }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ label("PasswordSQL", "Password SQL") }}</mat-label>
          <input
            matInput
            [type]="passwordHidden ? 'password' : 'text'"
            formControlName="SQLPassword"
          />
          <button
            mat-icon-button
            type="button"
            (click)="passwordHidden = !passwordHidden"
            matSuffix
            [matTooltip]="
              passwordHidden
                ? label('MostrarPassword', 'Mostrar password')
                : label('OcultarPassword', 'Ocultar password')
            "
          >
            <mat-icon>{{ passwordHidden ? "visibility" : "visibility_off" }}</mat-icon>
          </button>
          <mat-error *ngIf="df['SQLPassword'].hasError('pattern')">
            {{ label("FormatoPasswordSQLInvalido", "Formato de contraseña no permitido") }}
          </mat-error>
        </mat-form-field>
      </div>
    </mat-card>

    <!-- Tipos de Control - só visível para KUROI -->
    <mat-card class="relacion-card" *ngIf="mostrarDualListTiposControl">
      <mat-card-title>{{ label("TiposControl", "Tipos de Control") }}</mat-card-title>
      <div class="dual-list-wrapper">
        <customan-dual-list
          #tiposControlDualList
          class="dual-list"
          [source]="tiposControlDisponibles"
          [(destination)]="tiposControlAsignados"
          key="CodigoTipoControl"
          display="Nombre"
          [actionTemplate]="tipoControlAction"
          [format]="format"
          [filter]="true"
        ></customan-dual-list>
      </div>
      <div class="error-text" *ngIf="submitted && mostrarDualListTiposControl && !tiposControlAsignados.length">
        {{ label("TiposControlRequeridos", "Debe asignar al menos un Tipo de Control") }}
      </div>

    </mat-card>

    <ng-template #tipoControlAction let-item>
      <button mat-raised-button color="accent" (click)="editTipoControl(item)">
        {{ label("Editar", "Editar") }}
      </button>
    </ng-template>

    <!--
      Centros: grid desactivado temporalmente.
      La API todavía no persiste CentrosIds para KUROI, por lo que el dual-list
      de Centros se oculta hasta que el backend implemente esta parte.
    -->
    <!--
    <mat-card class="relacion-card">
      <mat-card-title>{{ label("Centros", "Centros") }}</mat-card-title>
      <div class="dual-list-wrapper">
        <customan-dual-list
          class="dual-list"
          [source]="centrosDisponibles"
          [(destination)]="centrosAsignados"
          key="pkId"
          display="Nombre"
          [format]="format"
          [filter]="true"
          (add)="addCentros($event)"
          (remove)="removeCentros($event)"
        ></customan-dual-list>
      </div>
    </mat-card>
    -->
  </div>
</div>

<div
  class="tipo-control-editor-overlay"
  *ngIf="tipoControlEditorVisible"
>
  <div #tipoControlEditorContainer class="tipo-control-editor-container">
    <app-access-control-tipo-control-dialog
      [tipo]="tipoControlEnEdicion"
      [translation]="translation"
      (saveRequested)="onTipoControlEditorSave($event)"
      (cancelRequested)="onTipoControlEditorCancel()"
    ></app-access-control-tipo-control-dialog>
  </div>
</div>

